<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"parkCode":"2KKN6111","phone":"18200946810","carCode":"","credits":"10","billCode":"20170901140630384"},
            responseCode: {"data":{},"message":"业务成功","resultCode":0,"status":1}	,
            infoData: {
                explain: "智慧停车开放平台主动请求第三方接入系统冲正用户积分",
                urlPattern: this.commonUrls.third+"reverseUserCredits",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'phone', info2: '否', info3: 'String', info4: '用户手机号（与车牌号必填一个）' },
                        { info1: 'carCode', info2: '否', info3: 'String', info4: '车牌号（与手机号必填一个）' },
                        { info1: 'credits', info2: '是', info3: 'int', info4: '冲正的积分数' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '流水号' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/score/reverseUserCreditsByCoop.vue